import React from 'react';
import LocalizedLink from '../LocalizedLink';
import Translate from '../Translate/Translate';
import NewsLetter from '../Content/NewsLetter';
import LogoBig from '../../images/rademar_logo_green.svg';

export default function Footer2() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="max-w-(--breakpoint-3xl) mx-auto">
      <div className="footer bg-black text-white">
        <div className="social text-xl sm:text-2xl leading-10 font-axi-bold grid grid-cols-2 lg:grid-cols-4 text-center flex-col border-b border-rgrey-darker pt-8 lg:pt-0">
          <div
            className="flex justify-center items-center py-4 md:py-8 px-5 md:px-11 text-white hover:text-rgreen"
            tabIndex={0}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 mr-2"
              aria-hidden="true"
            >
              <mask
                id="mask0_682_860_newsletter"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="currentColor" />
              </mask>
              <g mask="url(#mask0_682_860_newsletter)">
                <path
                  d="M4 17C3.45 17 2.97917 16.8042 2.5875 16.4125C2.19583 16.0208 2 15.55 2 15V7.15C2 6.9 2.07083 6.65417 2.2125 6.4125C2.35417 6.17083 2.55 5.98333 2.8 5.85L10.5 2L18.05 5.85C18.25 5.95 18.4208 6.10833 18.5625 6.325C18.7042 6.54167 18.8 6.76667 18.85 7H15.925L10.5 4.25L4 7.475V17ZM7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V10C5 9.45 5.19583 8.97917 5.5875 8.5875C5.97917 8.19583 6.45 8 7 8H20C20.55 8 21.0208 8.19583 21.4125 8.5875C21.8042 8.97917 22 9.45 22 10V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H7ZM13.5 15.35L7 12V19H20V12L13.5 15.35ZM13.5 13.35L20 10H7L13.5 13.35Z"
                  fill="currentColor"
                />
              </g>
            </svg>
            <NewsLetter />
          </div>
          <a
            className="flex justify-center items-center py-4 md:py-8 px-5 md:px-11 text-white hover:text-rgreen"
            href="https://www.facebook.com/rademar.ee/"
            target="_blank"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 mr-2"
              aria-hidden="true"
            >
              <mask
                id="mask0_682_726_facebook"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="currentColor" />
              </mask>
              <g mask="url(#mask0_682_726_facebook)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17 2C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2H17ZM7 4C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H10V15H9V13H10V11C10 8.79086 11.7909 7 14 7H16V9H14C12.8954 9 12 9.89543 12 11V13H15V15H12V20H17C18.6569 20 20 18.6569 20 17V7C20 5.34315 18.6569 4 17 4H7Z"
                  fill="currentColor"
                />
              </g>
            </svg>
            Facebook
          </a>
          <a
            className="flex justify-center items-center py-4 md:py-8 px-5 md:px-11 text-white hover:text-rgreen"
            href="https://www.instagram.com/rademar.ee/?hl=en"
            target="_blank"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 mr-2"
              aria-hidden="true"
            >
              <mask
                id="mask0_682_842_instagram"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="currentColor" />
              </mask>
              <g mask="url(#mask0_682_842_instagram)">
                <path
                  d="M20 7C20 5.34315 18.6569 4 17 4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V7ZM22 17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17Z"
                  fill="currentColor"
                />
                <path
                  d="M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15V17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17V15C13.6569 15 15 13.6569 15 12Z"
                  fill="currentColor"
                />
                <path
                  d="M18 7C18 7.55228 17.5523 8 17 8C16.4477 8 16 7.55228 16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7Z"
                  fill="currentColor"
                />
              </g>
            </svg>
            Instagram
          </a>
          <a
            className="flex justify-center items-center py-4 md:py-8 px-5 md:px-11 text-white hover:text-rgreen"
            href="https://www.youtube.com/@rademarestonia/featured"
            target="_blank"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 mr-2"
              aria-hidden="true"
            >
              <mask
                id="mask0_682_661_youtube"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="currentColor" />
              </mask>
              <g mask="url(#mask0_682_661_youtube)">
                <path
                  d="M21 9C21 7.34315 19.6569 6 18 6H6C4.34315 6 3 7.34315 3 9V15C3 16.6569 4.34315 18 6 18H18C19.6569 18 21 16.6569 21 15V9ZM23 15C23 17.7614 20.7614 20 18 20H6C3.23858 20 1 17.7614 1 15V9C1 6.23858 3.23858 4 6 4H18C20.7614 4 23 6.23858 23 9V15Z"
                  fill="currentColor"
                />
                <path
                  d="M10 14.5892V9.41084C10 9.01629 10.4356 8.77718 10.7684 8.98901L14.8371 11.5782C15.1459 11.7746 15.1459 12.2254 14.8371 12.4218L10.7684 15.011C10.4356 15.2228 10 14.9837 10 14.5892Z"
                  fill="currentColor"
                />
              </g>
            </svg>
            Youtube
          </a>
        </div>

        <div className="flex flex-col mt-14">
          <div className="lg:grid lg:grid-cols-2 lg:gap-x-32 lg:border-b border-rgrey-darker lg:pb-14">
            <div className="flex-1 mb-4 text-2xl leading-10 mx-8 md:mx-4 lg:mx-8">
              <p className="font-axi-bold mb-2">
                Vajad infot toodete, tellitud kauba või muu e-poega seonduva
                kohta?
              </p>
              <a
                className="underline font-axi-book"
                href="mailto:epood@rademar.ee"
              >
                epood@rademar.ee
              </a>
              <a
                href="tel:+372 61 541 38"
                className="block underline font-axi-book"
              >
                +372 615 4138
              </a>
              <p className="font-axi-book">E-R 09:00-16:30</p>
            </div>
            <div className="flex flex-col md:grid md:grid-cols-3 border-b border-rgrey-darker text-sm gap-y-6 mt-14 pb-14 lg:mt-2 lg:border-b-0 lg:pb-0">
              <ul className="mx-8 md:mx-4 lg:mx-8">
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/tooted/naised'}>
                    <Translate component="footer" keyword="women" />
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/tooted/mehed'}>
                    <Translate component="footer" keyword="men" />
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/tooted/lapsed'}>
                    <Translate component="footer" keyword="kids" />
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink
                    onClick={scrollToTop}
                    to={'/tooted/aksessuaarid'}
                  >
                    <Translate component="footer" keyword="accessories" />
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink
                    onClick={scrollToTop}
                    to={'/tooted/spordivahendid'}
                  >
                    <Translate component="footer" keyword="equipment" />
                  </LocalizedLink>
                </li>
                {/* <li className="mb-2">
                <LocalizedLink
                  onClick={scrollToTop}
                  to={'/tooted/spordivahendid'}
                >
                  <Translate component="footer" keyword="equipment" /> 
                  <span>Sooduspakkumised</span>
                </LocalizedLink>
              </li> */}
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/brandid'}>
                    <Translate component="footer" keyword="brands" />
                  </LocalizedLink>
                </li>
              </ul>
              <ul className="mx-8 md:mx-4 lg:mx-8">
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/ostmine'}>
                    Ostmine
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/tarne'}>
                    Tarne
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/tagastamine'}>
                    <Translate component="footer" keyword="tagastamine" />
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/tingimused'}>
                    Kasutustingimused
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink
                    onClick={scrollToTop}
                    to={'/privaatsuspoliitika'}
                  >
                    Privaatsuspoliitika
                  </LocalizedLink>
                </li>
              </ul>
              <ul className="mx-8 md:mx-4 lg:mx-8">
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/ettevottest'}>
                    <Translate component="footer" keyword="about-us" />
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/tule-toole'}>
                    <Translate component="footer" keyword="jobs" />
                  </LocalizedLink>
                </li>
                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/kauplused'}>
                    <Translate component="footer" keyword="stores" />
                  </LocalizedLink>
                </li>

                <li className="mb-2">
                  <LocalizedLink onClick={scrollToTop} to={'/blogi'}>
                    <Translate component="footer" keyword="news" />
                  </LocalizedLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col border-b border-rgrey-darker mt-14 pb-14 gap-y-6 lg:flex-row lg:gap-x-6">
            <div className="text-base leading-7 mx-8 md:mx-4 lg:mx-8">
              <p className="font-axi-bold mb-2">
                Soovid teha koostööd? Võta ühendust!
              </p>
              <a
                className="underline font-axi-book"
                href="mailto:koostoo@rademar.ee"
              >
                koostoo@rademar.ee
              </a>
            </div>
            <div className="text-base leading-7 mx-8 md:mx-4 lg:mx-8">
              <p className="font-axi-bold mb-2">
                Kas sul on meiega seoses mõni muu küsimus? Küsi julgelt!
              </p>
              <a
                className="underline font-axi-book"
                href="mailto:info@rademar.ee"
              >
                info@rademar.ee
              </a>
              <a
                href="tel:+372 61 541 30"
                className="block underline font-axi-book"
              >
                +372 615 4130
              </a>
            </div>
          </div>
          <div className="mt-6 mb-16 mx-2 md:mx-8">
            <div className="flex justify-between items-center">
              <img src={LogoBig} className="w-36 h-8 min-w-36" alt="Rademar" />
              <span className="text-sm font-axi-book">
                © Rademar {new Date().getFullYear()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
